import { datetimeFormatter, defaultFormatter } from 'utils/formatters';

export const REPORT_COLUMNS = [
  {
    label: 'Data/Hora',
    value: ({ date }) => datetimeFormatter(date),
    sort: 'date',
  },
  {
    label: 'Usuário',
    value: ({ user }) => defaultFormatter(user.username),
    sort: 'user.username'
  },
  {
    label: 'IP',
    value: ({ ip }) => defaultFormatter(ip),
    sort: 'ip'
  },
  {
    label: 'Descrição',
    value: ({ description }) => defaultFormatter(description),
  },
]